import {combineReducers} from 'redux'
import {currentLanguage} from '@redux/reducers/languageReducer';
import {brandSocials} from '@redux/reducers/socialReducer';
import {footerSticky} from '@redux/reducers/footerReducer';
import {navigatorHelper} from '@redux/reducers/navigator';

export default combineReducers({
    currentLanguage
    , brandSocials
    , footerSticky
    , navigatorHelper
})


